import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { apiClientV2 } from '~/api/client';

interface ISaveListSendMessageProps {
  creatorId: string;
  message: string;
  name: string;
  email: string;
  company: string;
  savedListId: string;
  sharedLinktOwnerId: string;
}

export const useSavedListSendMessage = ({
  sharedToken,
}: {
  sharedToken?: string;
}) => {
  return useMutation<AxiosResponse, AxiosError, ISaveListSendMessageProps>(
    ({
      creatorId,
      message,
      name,
      email,
      company,
      savedListId,
      sharedLinktOwnerId,
    }) =>
      apiClientV2.post(
        `/creators/${creatorId}/brand-interest-request`,
        {
          message,
          name,
          email,
          company,
          saved_list_id: savedListId,
          shared_link_owner_id: sharedLinktOwnerId,
        },
        {
          headers: {
            'X-AUTH-TOKEN': `${sharedToken}`,
          },
        },
      ),
  );
};
